import axios from 'axios';

import lstModules from 'common/json/lstModules.json';



const httpURL = lstModules['performance'].url + ':'
    + lstModules['performance'].port
    + "/sms/hpc/parent";

export function getActivityListSvc(schoolId, acdYrId, studentId, clsId, callback) {
    // console.log("getActivityListSvc called, schoolId", schoolId, ", acdYrId", acdYrId, ",  studentId", studentId);
    let obj = { status: 'Success', message: "" };
    axios({
        url: httpURL + '/list_activity',
        method: 'POST',
        params: { schoolId, acdYrId, studentId, clsId },
        withCredentials: false
    })
        .then((response) => {
            obj.message = response.data.SvcMsg;
            obj.status = response.data.SvcStatus;
            if (response.data.SvcStatus === "Success") {
                obj.lstActivity = response.data.lstActivity;
            }
            callback(obj)
        }).catch((error) => {
            obj.status = 'Exception';
            obj.message = error;
            callback(obj)
        });
}

export function getStudentGeneralInfoSvc(schoolId, acdYrId, studentId, clsId, callback) {
    // console.log("getStudentGeneralInfoSvc called, schoolId", schoolId, ", acdYrId", acdYrId, ",  studentId", studentId);
    let obj = { status: 'Success', message: "" };
    axios({
        url: httpURL + '/get_general_info',
        method: 'POST',
        params: { schoolId, acdYrId, studentId, clsId },
        withCredentials: false
    })
        .then((response) => {
            obj.message = response.data.SvcMsg;
            obj.status = response.data.SvcStatus;
            if (response.data.SvcStatus === "Success") {
                obj.generalInfo = response.data.generalInfo;
                obj.basePath = response.data.basePath;
            }
            callback(obj)
        }).catch((error) => {
            obj.status = 'Exception';
            obj.message = error;
            callback(obj)
        });
}
export function saveStudentGeneralInfoSvc(schoolId, acdYrId, studentId, clsId, generalInfoObj, imgFile, callback) {
    // console.log("saveStudentGeneralInfoSvc called, schoolId", schoolId, ", acdYrId", acdYrId);
    // console.log("  studentId", studentId, ", generalInfoObj", generalInfoObj);
    let obj = { status: 'Success', message: "" };
    const formData = new FormData();
    formData.append("schoolId", schoolId);
    formData.append("acdYrId", acdYrId);
    formData.append("studentId", studentId);
    formData.append("clsId", clsId);
    formData.append("objGeneralInfo", JSON.stringify(generalInfoObj));
    formData.append("imgFamilyPhoto", imgFile);
    axios({
        url: httpURL + '/save_general_info',
        method: 'POST',
        data: formData,
        withCredentials: false
    })
        .then((response) => {
            obj.message = response.data.SvcMsg;
            obj.status = response.data.SvcStatus;
            callback(obj)
        }).catch((error) => {
            obj.status = 'Exception';
            obj.message = error;
            callback(obj)
        });
}



export function getStudentInterestListSvc(schoolId, acdYrId, studentId, clsId, callback) {
    // console.log("getStudentInterestListSvc called, schoolId", schoolId, ", acdYrId", acdYrId, ",  studentId", studentId);
    let obj = { status: 'Success', message: "" };
    axios({
        url: httpURL + '/list_interest',
        method: 'POST',
        params: { schoolId, acdYrId, studentId, clsId },
        withCredentials: false
    })
        .then((response) => {
            obj.message = response.data.SvcMsg;
            obj.status = response.data.SvcStatus;
            if (response.data.SvcStatus === "Success") {
                obj.lstInterest = response.data.lstInterest;
            }
            callback(obj)
        }).catch((error) => {
            obj.status = 'Exception';
            obj.message = error;
            callback(obj)
        });
}
export function saveStudentsInterestsSvc(schoolId, acdYrId, studentId, clsId, lstInterest, callback) {
    // console.log("saveStudentsInterestsSvc called, schoolId", schoolId, ", acdYrId", acdYrId);
    // console.log("  studentId", studentId, ", lstInterest", lstInterest);
    let obj = { status: 'Success', message: "" };
    const formData = new FormData();
    formData.append("schoolId", schoolId);
    formData.append("acdYrId", acdYrId);
    formData.append("studentId", studentId);
    formData.append("clsId", clsId);
    formData.append("lstInterest", JSON.stringify(lstInterest));
    axios({
        url: httpURL + '/save_interest',
        method: 'POST',
        data: formData,
        withCredentials: false
    })
        .then((response) => {
            obj.message = response.data.SvcMsg;
            obj.status = response.data.SvcStatus;
            if (response.data.SvcStatus === "Success") {
            }
            callback(obj)
        }).catch((error) => {
            obj.status = 'Exception';
            obj.message = error;
            callback(obj)
        });
}
export function getStudentFavouritesListSvc(schoolId, acdYrId, studentId, clsId, callback) {
    // console.log("getStudentFavouritesListSvc called, schoolId", schoolId, ", acdYrId", acdYrId, ",  studentId", studentId);
    let obj = { status: 'Success', message: "" };
    axios({
        url: httpURL + '/get_favourite',
        method: 'POST',
        params: { schoolId, acdYrId, studentId, clsId },
        withCredentials: false
    })
        .then((response) => {
            obj.message = response.data.SvcMsg;
            obj.status = response.data.SvcStatus;
            if (response.data.SvcStatus === "Success") {
                obj.favouriteObj = response.data.favouriteObj;
            }
            callback(obj)
        }).catch((error) => {
            obj.status = 'Exception';
            obj.message = error;
            callback(obj)
        });
}
export function saveStudentsFavouritesSvc(schoolId, acdYrId, studentId, clsId, objFavourite, callback) {
    // console.log("saveStudentsFavouritesSvc called, schoolId", schoolId, ", acdYrId", acdYrId);
    // console.log("  studentId", studentId, ", objFavourite", objFavourite);
    let obj = { status: 'Success', message: "" };
    const formData = new FormData();
    formData.append("schoolId", schoolId);
    formData.append("acdYrId", acdYrId);
    formData.append("studentId", studentId);
    formData.append("clsId", clsId);
    formData.append("objFavourite", JSON.stringify(objFavourite));
    axios({
        url: httpURL + '/save_favourite',
        method: 'POST',
        data: formData,
        withCredentials: false
    })
        .then((response) => {
            obj.message = response.data.SvcMsg;
            obj.status = response.data.SvcStatus;
            if (response.data.SvcStatus === "Success") {
            }
            callback(obj)
        }).catch((error) => {
            obj.status = 'Exception';
            obj.message = error;
            callback(obj)
        });
}
export function getStudentFriendsSvc(schoolId, acdYrId, studentId, clsId, callback) {
    // console.log("getStudentFriendsSvc called, schoolId", schoolId, ", acdYrId", acdYrId, ",  studentId", studentId);
    let obj = { status: 'Success', message: "" };
    axios({
        url: httpURL + '/get_friend',
        method: 'POST',
        params: { schoolId, acdYrId, studentId, clsId },
        withCredentials: false
    })
        .then((response) => {
            obj.message = response.data.SvcMsg;
            obj.status = response.data.SvcStatus;
            if (response.data.SvcStatus === "Success") {
                obj.lstFriend = response.data.lstFriend;
            }
            callback(obj)
        }).catch((error) => {
            obj.status = 'Exception';
            obj.message = error;
            callback(obj)
        });
}
export function getStudentResourcesListSvc(schoolId, acdYrId, studentId, clsId, callback) {
    // console.log("getStudentResourcesListSvc called, schoolId", schoolId, ", acdYrId", acdYrId, ",  studentId", studentId);
    let obj = { status: 'Success', message: "" };
    axios({
        url: httpURL + '/get_friend',
        method: 'POST',
        params: { schoolId, acdYrId, studentId, clsId },
        withCredentials: false
    })
        .then((response) => {
            obj.message = response.data.SvcMsg;
            obj.status = response.data.SvcStatus;
            if (response.data.SvcStatus === "Success") {
                obj.resourcesObj = response.data.resourcesObj;
            }
            callback(obj)
        }).catch((error) => {
            obj.status = 'Exception';
            obj.message = error;
            callback(obj)
        });
}

export function getStudentAssessmentInfoSvc(schoolId, acdYrId, studentId, clsId, callback) {
    // console.log("getStudentAssessmentInfoSvc called, schoolId", schoolId, ", acdYrId", acdYrId, ",  studentId", studentId);
    let obj = { status: 'Success', message: "" };
    axios({
        url: httpURL + '/list_assessment_info',
        method: 'POST',
        params: { schoolId, acdYrId, studentId, clsId },
        withCredentials: false
    })
        .then((response) => {
            // console.log("response in getStudentAssessmentInfoSvc", response);
            obj.message = response.data.SvcMsg;
            obj.status = response.data.SvcStatus;
            if (response.data.SvcStatus === "Success") {
                obj.lstStudentInfo = response.data.lstStudentInfo;
                obj.basePathActivity = response.data.basePathActivity;
            }
            callback(obj)
        }).catch((error) => {
            obj.status = 'Exception';
            obj.message = error;
            callback(obj)
        });
}

